let privately = [
  {
    path: '/privately_adv_detail',
    name: '活动详情',
    component: () => import('@/pages/privately/privately_adv_detail')
  },
  {
    path: '/privately_order_list',
    name: '订单列表',
    component: () => import('@/pages/privately/privately_order_list')
  },
  {
    path: '/privately_environment_detail',
    name: '环境展示',
    component: () => import('@/pages/privately/privately_environment_detail')
  },
  {
    path: '/privately_order_detail',
    name: '订单详情',
    component: () => import('@/pages/privately/privately_order_detail')
  },
  {
    path: '/privately_index',
    name: '专病专诊',
    component: () => import('@/pages/privately/privately_index_new')
  },
  {
    path: '/privately_index_v3',
    name: '新专病专诊',
    component: () => import('@/pages/privately/privately_index_v3')
  },
  {
    path: '/privately_search_v3',
    name: '专病专诊医生搜索',
    component: () => import('@/pages/privately/privately_search_v3')
  },
  {
    path: '/privately_all_dep',
    name: '全部科室',
    component: () => import('@/pages/privately/privately_all_dep')
  },
  {
    path: '/privately_all_doc',
    name: '全部医生',
    component: () => import('@/pages/privately/privately_all_doc')
  },
  {
    path: '/privately_expert_goodAt',
    name: '专家特长',
    component: () => import('@/pages/privately/privately_expert_goodAt')
  },
  {
    path: '/privately_expert_goodAt_new',
    name: '专家特长',
    component: () => import('@/pages/privately/privately_expert_goodAt_new')
  },
  {
    path: '/privately_adv_list',
    name: '活动列表',
    component: () => import('@/pages/privately/privately_adv_list')
  },
  {
    path: '/privately_star_list',
    name: '患者评价',
    component: () => import('@/pages/privately/privately_star_list')
  },
  {
    path: '/privately_star_list_new',
    name: '患者评价',
    component: () => import('@/pages/privately/privately_star_list_new')
  },
  {
    // path: '/privately_hosList',
    path: '/privately_hosList_new',
    name: '医院列表',
    component: () => import('@/pages/privately/privately_hosList_new.vue')
  },
  {
    // path: '/privately_hosList',
    path: '/privately_hosList_v3',
    name: '医院列表',
    component: () => import('@/pages/privately/privately_hosList_v3')
  },
  {
    path: '/privately_depList',
    name: '科室列表',
    component: () => import('@/pages/privately/privately_depList')
  },
  {
    path: '/privately_doc_list',
    name: '医生列表',
    component: () => import('@/pages/privately/privately_doc_list')
  },
  {
    path: '/privately_hospital_index',
    name: '医院主页',
    component: () => import('@/pages/privately/privately_hospital_index')
  }
]

export default privately
